'use strict';

var ACTION_TYPES = require('./actionTypes');

module.exports = {
  productConfigurationSelected: function productConfigurationSelected(spin, pconfId, isFullColorMaterial, currentModelJson) {
    return {
      type: ACTION_TYPES.PRODUCT_CONFIGURATION_SELECTED,
      payload: {
        spin: spin,
        productConfigurationId: pconfId,
        isFullColorMaterial: isFullColorMaterial,
        currentModelJson: currentModelJson
      }
    };
  },

  customMakerModelSelected: function customMakerModelSelected(spin, pconfId, modelId, customMakerFragmentUrls) {
    return {
      type: ACTION_TYPES.CUSTOM_MAKER_MODEL_SELECTED,
      payload: {
        spin: spin,
        productConfigurationId: pconfId,
        modelId: modelId,
        customMakerFragmentUrls: customMakerFragmentUrls
      }
    };
  },

  previewMainImageSlideshow: function previewMainImageSlideshow(previewImageUrl, previewImageCaption, isShapewaysMaterialRender) {
    return {
      type: ACTION_TYPES.PREVIEW_MAIN_IMAGE_SLIDESHOW,
      payload: {
        previewImageUrl: previewImageUrl,
        previewImageCaption: previewImageCaption,
        isShapewaysMaterialRender: isShapewaysMaterialRender
      }
    };
  },

  /**
   * Dispatch from ShapeJsRT if gpu servers are available or not
   * @param shapeJsId
   * @param isAvailable
   * @returns {{type: string, payload: {shapeJsId: string, isAvailable: boolean}}}
   */
  shapeJsIsAvailable: function shapeJsIsAvailable(shapeJsId, isAvailable) {
    return {
      type: ACTION_TYPES.SHAPE_JS_VIEWER_IS_AVAILABLE,
      payload: {
        shapeJsId: shapeJsId,
        isAvailable: !!isAvailable
      }
    };
  },

  /**
   * Activate ShapeJs
   * @param shapeJsId
   * @returns {{type: string, payload: {shapeJsId: string}}}
   */
  activateShapeJs: function activateShapeJs(shapeJsId) {
    return {
      type: ACTION_TYPES.SHAPE_JS_VIEWER_ACTIVATE,
      payload: {
        shapeJsId: shapeJsId
      }
    };
  },

  /**
   * Show/hide ShapeJs
   * @param shapeJsId
   * @param isActive
   * @returns {{type: string, payload: {shapeJsId: string, isActive: boolean}}}
   */
  shapeJsIsActive: function shapeJsIsActive(shapeJsId, isActive) {
    return {
      type: ACTION_TYPES.SHAPE_JS_VIEWER_IS_ACTIVE,
      payload: {
        shapeJsId: shapeJsId,
        isActive: !!isActive
      }
    };
  },

  /**
   * ShapeJs start loading
   * @param shapeJsId
   * @returns {{type: string, payload: {shapeJsId: string}}}
   */
  startPreventInteractionShapeJs: function startPreventInteractionShapeJs(shapeJsId) {
    return {
      type: ACTION_TYPES.SHAPE_JS_VIEWER_START_PREVENT_INTERACTION,
      payload: {
        shapeJsId: shapeJsId
      }
    };
  },

  /**
   * ShapeJs stop loading
   * @param shapeJsId
   * @returns {{type: string, payload: {shapeJsId: string}}}
   */
  stopPreventInteractionShapeJs: function stopPreventInteractionShapeJs(shapeJsId) {
    return {
      type: ACTION_TYPES.SHAPE_JS_VIEWER_STOP_PREVENT_INTERACTION,
      payload: {
        shapeJsId: shapeJsId
      }
    };
  },

  /**
   * ShapeJs show loading spinner
   * @param shapeJsId
   * @param isLoading
   * @returns {{type: string, payload: {shapeJsId: string, isLoading: boolean}}}
   */
  shapeJsIsLoading: function shapeJsIsLoading(shapeJsId, isLoading) {
    return {
      type: ACTION_TYPES.SHAPE_JS_VIEWER_IS_LOADING,
      payload: {
        shapeJsId: shapeJsId,
        isLoading: !!isLoading
      }
    };
  }
};
